var map = {
	"./avispace/app/shared/object-collection/shared/badges/type-badge/type-badge.component": [
		4478,
		[
			"common",
			"src_themes_avispace_app_shared_object-collection_shared_badges_type-badge_type-badge_component_ts"
		]
	],
	"./custom/app/shared/object-collection/shared/badges/type-badge/type-badge.component": [
		94323,
		[
			"common",
			"src_themes_custom_app_shared_object-collection_shared_badges_type-badge_type-badge_component_ts"
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 45796;
module.exports = webpackAsyncContext;